// 22.01.19 - This container is for our View Cases table. Defines the data that view cases needs.
import { connect } from "react-redux";
// import { getCaseData } from "../actions/home";
import {
  getCaseDataByUser,
  actionGetGridData,
  actionExportClaimData,
  actionExportComplaintData,
  actionExportIncidentReportData,
} from "../actions/home";
import HomeComponent from "../components/home";
import { selectCase } from "src/actions/detail";
import { IRootState } from "src/reducers";
import { generalStyles } from "src/styles/general";
import { WithStyles } from "@material-ui/core";
import { openToaster, closeToaster } from "src/actions/common";
// import { bindActionCreators } from "redux";

// Describes the data needed in the table.
export interface IHomeStateProps {
  caseData: IRootState["home"]["caseData"];
  currentUser: IRootState["home"]["currentUser"];
  countries: IRootState["detail"]["countries"];
  issueTypes: IRootState["detail"]["issueTypes"];
  claimStatus: IRootState["detail"]["claimStatus"];
  claimTypes: IRootState["detail"]["claimTypes"];
  gridData: any;
  showNoDataMessage: IRootState["home"]["showNoDataMessage"];
  allowFetchGridData: any;
  isLoaderVisible: IRootState["common"]["isLoaderVisible"];
  toasterMessage: IRootState["common"]["toasterMessage"];
  isToasterVisible: IRootState["common"]["isToasterVisible"];
  isSuccessMessage: IRootState["common"]["isSuccess"];
}

// Describes the arguments received by the app or the reducer.
export interface IHomeDispatchProps {
  // getCaseData: () => void;
  getCaseDataByUser: (roleId: string, userName: string) => void;
  selectCase: (uniqueId: string) => void;
  getGridData: (roleId: string, userName: string) => void;
  exportClaim: () => void;
  exportComplaint: () => void;
  exportIncidents: () => void;
  openToaster: (message: string, success: boolean) => void;
  closeToaster: () => void;
}

// This describes the combined types of data that the componenet will receive as above.
export type HomeProps = WithStyles<typeof generalStyles> &
  IHomeStateProps &
  IHomeDispatchProps;

// This pulls the data from IRootState that the table component needs.
function mapStateToProps(state: IRootState): IHomeStateProps {
  return {
    caseData: state.home.caseData,
    currentUser: state.home.currentUser,
    countries: state.detail.countries,
    issueTypes: state.detail.issueTypes,
    claimStatus: state.detail.claimStatus,
    gridData: state.home.gridData,
    claimTypes: state.detail.claimTypes,
    showNoDataMessage: state.home.showNoDataMessage,
    allowFetchGridData: state.common.allowFetchGridData,
    isLoaderVisible: state.common.isLoaderVisible,
    toasterMessage: state.common.toasterMessage,
    isToasterVisible: state.common.isToasterVisible,
    isSuccessMessage: state.common.isSuccess,
  };
}

// This pulls the functions that the table component needs to dispatch events to our state store.
// const mapDispatchToProps = dispatch => bindActionCreators(
//       {
//         //getCaseData,
//         getCaseDataByUser,
//         selectCase,
//         getGridData: actionGetGridData
//       }, dispatch
//   );

const mapDispatchToProps = (dispatch: any) => {
  return {
    getCaseDataByUser: (roleId: string, userName: string) =>
      dispatch(getCaseDataByUser(roleId, userName)),
    selectCase: (uniqueId: string) => dispatch(selectCase(uniqueId)),
    getGridData: (roleId: string, userName: string) =>
      dispatch(actionGetGridData(roleId, userName)),
    exportClaim: () => dispatch(actionExportClaimData()),
    exportComplaint: () => dispatch(actionExportComplaintData()),
    exportIncidents: () => dispatch(actionExportIncidentReportData()),
    openToaster: (message: string, success: boolean) =>
      dispatch(openToaster(message, success)),
    closeToaster: () => dispatch(closeToaster()),
  };
};

// This connects to the Redux state store and gives it access to dispatch the specific actions.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeComponent);
